import React from "react";
import { FormattedMessage } from "react-intl";
import "./choice.scss";

import { Text, Icon } from "@ui-kit";
import { RIGHT_PRODUCTS } from "./choice.consts";

const Choice = () => {
  return (
    <div className="choice__main-container">
      <div className="main__container d-flex">
        <div className="choice__description">
          <Text as="h1" className="title mb-20">
            <FormattedMessage
              id="choice.title"
              defaultMessage="Why choose KeyHunter?"
            />
          </Text>
        </div>
        <div className="choice__content fw-wrap d-flex">
          {RIGHT_PRODUCTS.map((item, index) => (
            <div key={`item-${index}`} className="choice__item">
              <div className="icon">
                <Icon src={item.ico} alt={item.alt} />
              </div>
              <div className="choice__item-content">
                <Text as="h3" className="title">
                  <FormattedMessage
                    id={`choice.content.item${index+1}.title`}
                    defaultMessage={item.title}
                  />
                </Text>
                <Text as="h5" className="description">
                  <FormattedMessage
                    id={`choice.content.item${index+1}.description`}
                    defaultMessage={item.description}
                  />
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Choice;
